/* global $ */
import React, { useState } from "react";

const PlacementCellRequirement = () => {
    document.title = "Placement Cell Requirements - CGES.CLUB";
    return (
        <>
            <PlacementOfficerForm />
        </>
    )
};

export default PlacementCellRequirement;


function PlacementOfficerForm() {
    const [validated, setValidated] = useState(false);
    const [internshipNeeded, setInternshipNeeded] = useState(null);
    const [scholarshipNeeded, setScholarshipNeeded] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const scrollToFirstError = (form) => {
        const firstInvalid = form.querySelector(
            "input:invalid, textarea:invalid, select:invalid"
        );

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            firstInvalid.focus();
        }
    };

    // -------- HELPER TO COLLECT CHECKBOX GROUPS --------
    const getCheckboxValues = (form, name) => {
        const checked = Array.from(
            form.querySelectorAll(`input[name="${name}"]:checked`)
        ).map(el => el.value);

        return checked.length ? checked.join(", ") : "";
    };

    const handleSubmit = async (e) => {
        const form = e.currentTarget;

        if (!form.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            scrollToFirstError(form);
        } else {
            e.preventDefault();

            // -------- ORDERED OBJECT (SAME AS FORM ORDER) --------
            let data = {
                // ===== 1. Institution Details =====
                "Institution Name": form["Institution Name"].value,
                "Type of Institution": form["Type of Institution"].value,
                "Type of Institution (Others)": form["Type of Institution (Others)"].value || "",
                "Address Line 1": form["Address Line 1"].value,
                "Address Line 2": form["Address Line 2"].value || "",
                "City": form["City"].value,
                "State": form["State"].value,
                "Country": form["Country"].value,
                "Contact Phone": form["Contact Phone"].value,
                "Website": form["Website"].value || "",

                // ===== 2. Placement Officer Details =====
                "Placement Officer Name": form["Placement Officer Name"].value,
                "Designation": form["Designation"].value,
                "Placement Officer Email": form["Placement Officer Email"].value,
                "Placement Officer Phone": form["Placement Officer Phone"].value,

                // ===== 3. Requirements from CGES.CLUB =====
                "Requirements from CGES.CLUB": getCheckboxValues(form, "requirements"),

                // ===== 4. Student Information =====
                "Total Students": form["Total Students"].value,
                "Main Student Streams": getCheckboxValues(form, "studentStreams"),
                "Student Streams (Others)": form["Student Streams (Others)"].value || "",

                // ===== 5. Internship Requirements =====
                "Internship Needed": form["Internship Needed"].value,
            };

            if (internshipNeeded) {
                data = {
                    ...data,
                    "Internship Students Count": form["Internship Students Count"].value,
                    "Internship Duration": form["Internship Duration"].value,
                    "Preferred Domains": getCheckboxValues(form, "internDomains"),
                    "Intern Domains (Others)": form["Intern Domains (Others)"].value || "",
                };
            }

            // ===== 6. Scholarship Requirements =====
            data = {
                ...data,
                "Scholarship Needed": form["Scholarship Needed"].value,
            };

            if (scholarshipNeeded) {
                data = {
                    ...data,
                    "Scholarship Categories": getCheckboxValues(form, "scholarCategories"),
                    "Scholarship Count": form["Scholarship Count"].value,
                };
            }

            // ===== 7. Campus Event Requirements =====
            data = {
                ...data,
                "Campus Events": getCheckboxValues(form, "campusEvents"),
                "Preferred Month": form["Preferred Month"].value || "",
            };

            // ===== 8. Additional Comments =====
            data = {
                ...data,
                "Additional Comments": form["Additional Comments"].value || "",
            };
            //   console.log("Collected Form Data:", data);
            //   return false;
            try {
                const response = await fetch("https://n8n.chennaigames.com/webhook/placement-cell-requirement", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                });
                
                if (response.ok) {
                    setSubmitted(true);
                } else {
                    alert("Failed to send details. Please try again.");
                }
            } catch (error) {
                console.error("Error sending form:", error);
                alert("Network error. Please try again.");
            }
        }

        setValidated(true);
    };

    return (
        <>
            <style>
                {`
        .form-head-block {
          padding-bottom: 16px;
          margin-bottom: 18px;
          border-bottom: 1px solid #2f2f2f;
        }

        .form-head-block h1 {
          font-size: clamp(1.2rem, 2.8vw, 1.9rem);
          font-weight: 700;
          margin: 0 0 10px;
          color: #ffffff;
        }

        .form-head-block p {
          margin: 0;
          color: #d6d6d6;
          line-height: 1.7;
          font-size: clamp(0.9rem, 1.8vw, 1.02rem);
        }

        .dark-card {
          background-color: #161616;
          color: #e4e4e4;
          border: 1px solid #2a2a2a;
          border-radius: 16px;
        }

        .dark-card h4, .dark-card h5 {
          color: #ff810e;
        }

        .dark-card label {
          color: #e4e4e4;
        }

        .dark-input {
          background-color: #000 !important;
          color: #e4e4e4 !important;
          border: 1px solid #333333;
        }

        .dark-card form label:not(.form-check-label) {
          display: inline-block;
          margin-bottom: 0.45rem;
          line-height: 1.4;
          font-weight: 500;
        }

        .dark-input:focus {
          border-color: #ff810e;
          box-shadow: 0 0 5px rgba(255, 129, 14, 0.5);
        }

        .form-check-input {
          background-color: #0b0f14;
          border: 1px solid #ff810e;
        }

        .form-check-input:checked {
          background-color: #ff810e;
          border-color: #ff810e;
        }

        .btn-orange {
          background-color: #ff810e;
          border: none;
          color: #000;
          font-weight: 600;
        }

        .btn-orange:hover {
          background-color: #e6730c;
        }

        .dark-shadow {
          box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);
        }

        .was-validated .form-control:valid,
        .form-control.is-valid {
          border-color: #333333 !important;
          background-image: none !important;
        }

        .was-validated .form-check-input:valid,
        .form-check-input.is-valid {
          border-color: #ff810e !important;
          background-image: none !important;
        }

        .was-validated .form-check-input:valid ~ .form-check-label,
        .form-check-label {
          color: #e4e4e4 !important;
        }

        .thank-you-box {
          background: #161616;
          color: #e4e4e4;
          padding: 40px;
          border-radius: 10px;
          text-align: center;
          box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);
        }

        .thank-you-box h3 {
          color: #ff810e;
        }

        .form-check {
          margin-bottom: 0.55rem;
          padding-left: 1.65rem;
        }

        .form-check-input {
          margin-top: 0.2rem;
        }

        .form-control {
          min-height: 44px;
        }

        .section-title {
          border-bottom: 1px solid #2f2f2f;
          padding-bottom: 8px;
          margin-top: 2rem !important;
          margin-bottom: 1rem;
        }

        .dark-card form .mb-3,
        .dark-card form .row {
          margin-bottom: 1rem !important;
        }

        .dark-card form .row {
          row-gap: 0.5rem;
        }

        .dark-card form button.btn {
          min-height: 44px;
          padding: 10px 24px;
          margin-top: 1.6rem !important;
        }

        .form-shell {
          max-width: 980px;
        }

        @media (max-width: 768px) {
          .form-head-block {
            margin-bottom: 14px;
            padding-bottom: 12px;
          }

          .dark-card {
            padding: 18px !important;
          }

          .container.mt-5.mb-5 {
            margin-top: 1.25rem !important;
            margin-bottom: 1.5rem !important;
          }

          .section-title {
            margin-top: 1.5rem !important;
          }
        }
        `}
            </style>

            <div className="container mt-5 mb-5 form-shell" style={{ marginTop: "100px" }}>
                <div className="card dark-card dark-shadow p-4">
                    <div className="form-head-block">
                        <h1>Placement Officer Requirement Form</h1>
                        <p>
                            Partner with CGES.CLUB for internships, scholarships, campus esports events,
                            training programs, and gaming-tech placement opportunities. Share your
                            institution requirements so we can build the best opportunities for your students.
                        </p>
                    </div>

                    {!submitted ? (
                        <>
                            <form
                                noValidate
                                className={validated ? "was-validated" : ""}
                                onSubmit={handleSubmit}
                            >

                                {/* ========== 1. INSTITUTION DETAILS ========== */}
                                <h5 className="mt-4 section-title">1. Institution Details</h5>

                                <div className="mb-3">
                                    <label>Institution Name *</label>
                                    <input
                                        type="text"
                                        name="Institution Name"
                                        className="form-control dark-input"
                                        required
                                        placeholder="Ex: Anna University (Max 150 characters)"
                                        maxLength={150}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Type of Institution *</label><br />
                                    {["College","University","Academy / Training Centre","Others"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                        type="radio"
                                        name="Type of Institution"
                                        value={v}
                                        required
                                        className="form-check-input"
                                        id={v}
                                        />
                                        <label className="form-check-label ms-2" htmlFor={v}>{v}</label>
                                    </div>
                                    ))}
                                    
                                    <input
                                        type="text"
                                        name="Type of Institution (Others)"
                                        className="form-control dark-input mt-2"
                                        placeholder="If others, specify (Max 150 characters)"
                                        maxLength={150}
                                    />
                                </div>

                                

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label>Address Line 1 *</label>
                                        <input
                                            type="text"
                                            name="Address Line 1"
                                            className="form-control dark-input"
                                            required
                                            placeholder="Max 100 characters"
                                            maxLength={100}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Address Line 2</label>
                                        <input
                                            type="text"
                                            name="Address Line 2"
                                            className="form-control dark-input"
                                            placeholder="Max 100 characters"
                                            maxLength={100}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label>City *</label>
                                        <input type="text" name="City" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label>State *</label>
                                        <input type="text" name="State" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label>Country *</label>
                                        <input type="text" name="Country" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label>Contact Phone No *</label>
                                    <input
                                        type="tel"
                                        name="Contact Phone"
                                        className="form-control dark-input"
                                        pattern="[0-9]{10}"
                                        required
                                        placeholder="10 digit phone number"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Website</label>
                                    <input type="url" name="Website" className="form-control dark-input" placeholder="Ex: https://edu.university.in" maxLength={150}/>
                                </div>

                                {/* ========== 2. PLACEMENT OFFICER DETAILS ========== */}
                                <h5 className="mt-4 section-title">2. Placement Officer / Coordinator Details</h5>

                                <div className="mb-3">
                                    <label>Name *</label>
                                    <input type="text" name="Placement Officer Name" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                </div>

                                <div className="mb-3">
                                    <label>Designation *</label>
                                    <input type="text" name="Designation" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                </div>

                                <div className="mb-3">
                                    <label>Email *</label>
                                    <input type="email" name="Placement Officer Email" className="form-control dark-input" required placeholder="Max 100 characters" maxLength={100} />
                                </div>

                                <div className="mb-3">
                                    <label>Phone / WhatsApp *</label>
                                    <input
                                        type="tel"
                                        name="Placement Officer Phone"
                                        className="form-control dark-input"
                                        pattern="[0-9]{10}"
                                        required
                                        placeholder="10 digit phone number"
                                    />
                                </div>

                                {/* ========== 3. REQUIREMENTS FROM CGES.CLUB ========== */}
                                <h5 className="mt-4 section-title">3. Requirement from CGES.CLUB</h5>

                                {[
                                    "Internship Opportunities for Students",
                                    "Paid Internship Programs",
                                    "Scholarships for Students",
                                    "Esports / Gaming Training Programs",
                                    "Placement Opportunities in Gaming Tech",
                                    "Campus Event Sponsorships",
                                    "Campus Gaming Events",
                                    "Corporate Tie-ups"
                                ].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input className="form-check-input" type="checkbox" name="requirements" value={v} id={v}/>
                                        <label className="form-check-label" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                {/* ========== 4. STUDENT INFORMATION ========== */}
                                <h5 className="mt-4 section-title">4. Student Information</h5>

                                <label>Total Number of Students *</label>
                                {["< 100", "100–500", "500–1000", "1000+"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="Total Students"
                                            value={v}
                                            required
                                            id={v}
                                        />
                                        <label className="form-check-label" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <label className="mt-3">Main Student Streams</label>
                                {["Engineering", "Arts & Science", "Management", "Polytechnic / Diploma"].map(v => (
                                    <div key={v} className="form-check text-light">
                                        <input className="form-check-input" type="checkbox" name="studentStreams" value={v} id={v}/>
                                        <label className="form-check-label" htmlFor={v}>{v}</label>
                                    </div>
                                ))}
                                <input
                                    type="text"
                                    name="Student Streams (Others)"
                                    className="form-control dark-input mt-2"
                                    placeholder="Others, specify"
                                />

                                {/* ========== 5. INTERNSHIP REQUIREMENTS ========== */}
                                <h5 className="mt-4 section-title">5. Internship Requirements</h5>

                                <label>Do you need internships? *</label><br />
                                <label className="me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="Internship Needed"
                                        value="Yes"
                                        onChange={() => setInternshipNeeded(true)}
                                        required
                                    /> Yes
                                </label>
                                <label>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="Internship Needed"
                                        value="No"
                                        onChange={() => setInternshipNeeded(false)}
                                        required
                                    /> No
                                </label>

                                {internshipNeeded && (
                                    <><br />
                                        <label className="mt-3">Number of Students per Year *</label>
                                        {["< 10", "10–25", "25–50", "50–100", "100+"].map(v => (
                                            <div key={v} className="form-check">
                                                <input className="form-check-input"
                                                    type="radio"
                                                    name="Internship Students Count"
                                                    value={v}
                                                    required 
                                                    id={v} />
                                                <label className="form-check-label" htmlFor={v}>{v}</label>
                                            </div>
                                        ))}

                                        <label className="mt-3">Preferred Internship Duration *</label>
                                        {["1 Month", "3 Months", "6 Months", "1 Year"].map(v => (
                                            <div key={v} className="form-check">
                                                <input className="form-check-input"
                                                    type="radio"
                                                    name="Internship Duration"
                                                    value={v}
                                                    required 
                                                    id={v} />
                                                <label className="form-check-label" htmlFor={v}>{v}</label>
                                            </div>
                                        ))}

                                        <label className="mt-3">Preferred Domains</label>
                                        {[
                                            "Game Programming", "Game Design", "Game Artworks",
                                            "ESports Management", "Backend Development", "UI/UX"
                                        ].map(v => (
                                            <div key={v} className="form-check">
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    name="internDomains"
                                                    value={v} id={v} />
                                                <label className="form-check-label" htmlFor={v}>{v}</label>
                                            </div>
                                        ))}
                                        <input
                                            type="text"
                                            name="Intern Domains (Others)"
                                            className="form-control dark-input mt-2"
                                            placeholder="Others, specify"
                                        />
                                    </>
                                )}

                                {/* ========== 6. SCHOLARSHIP REQUIREMENTS ========== */}
                                <h5 className="mt-4 section-title">6. Scholarship Requirements</h5>

                                <label>Are you looking for scholarships? *</label><br />
                                <label className="me-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="Scholarship Needed"
                                        value="Yes"
                                        onChange={() => setScholarshipNeeded(true)}
                                        required
                                    /> Yes
                                </label>
                                <label>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="Scholarship Needed"
                                        value="No"
                                        onChange={() => setScholarshipNeeded(false)}
                                        required
                                    /> No
                                </label>

                                {scholarshipNeeded && (
                                    <><br />
                                        <label className="mt-3">For which students</label>
                                        {[
                                            "Economically Weaker Talented Students",
                                            "Gaming Talented Students",
                                            "Sports / ESports Achievers"
                                        ].map(v => (
                                            <div key={v} className="form-check">
                                                <input className="form-check-input"
                                                    type="checkbox"
                                                    name="scholarCategories"
                                                    value={v} id={v} />
                                                <label className="form-check-label" htmlFor={v}>{v}</label>
                                            </div>
                                        ))}

                                        <label className="mt-3">Expected Number of Scholarships *</label>
                                        {["< 5", "5–10", "10–25", "25+"].map(v => (
                                            <div key={v} className="form-check">
                                                <input className="form-check-input"
                                                    type="radio"
                                                    name="Scholarship Count"
                                                    value={v}
                                                    required 
                                                    id={v} />
                                                <label className="form-check-label" htmlFor={v}>{v}</label>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {/* ========== 7. CAMPUS EVENT REQUIREMENTS ========== */}
                                <h5 className="mt-4 section-title">7. Campus Event Requirements</h5>

                                {[
                                    "Esports Tournament in Campus",
                                    "Gaming Workshop / Game Jam / Hackathon"
                                ].map(v => (
                                    <div key={v} className="form-check">
                                        <input className="form-check-input"
                                            type="checkbox"
                                            name="campusEvents"
                                            value={v} id={v} />
                                        <label className="form-check-label" htmlFor={v}>{v}</label>
                                    </div>
                                ))}

                                <div className="mt-3">
                                    <label>Preferred Month</label>
                                    <input
                                        type="text"
                                        name="Preferred Month"
                                        className="form-control dark-input"
                                    />
                                </div>

                                {/* ========== 8. ADDITIONAL COMMENTS ========== */}
                                <h5 className="mt-4 section-title">8. Additional Requirements / Comments</h5>
                                <textarea
                                    name="Additional Comments"
                                    className="form-control dark-input"
                                    rows="3"
                                ></textarea>

                                <button type="submit" className="btn btn-orange mt-4" style={{ color: "white" }}>
                                    Submit Form
                                </button>
                            </form>
                        </>
                    ) : (
                        <div className="thank-you-box">
                            <h3>Thank You for Your Interest! 🙌</h3>
                            <p className="mt-3">
                                Our team will review your requirement and contact you soon.
                            </p>
                            <p>Thanks for your interest.</p>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
}



